
import { defineComponent, onMounted, ref } from 'vue';
import UIButton from '@/components/UI/UIButton.vue';
import { makeRequest, METHODS, sendFile } from '@/utils/apiUtils';
import { showToast } from '@/hooks/useToast';
import UIModal from '@/components/UI/UIModal.vue';

export default defineComponent({
  name: 'AjustesLoad',
  components: {
    'ui-button': UIButton,
    'ui-modal': UIModal
  },
  setup() {
    const file = ref<File | null>(null);
    const isLoading = ref(false);
    const fileRef = ref<any | null>(null);
    const pickFile = () => {
      document.getElementById('fileinput')?.click();
    };
    const charge = () => {
      const checkOnCancel = () => {
        const fileElem = document.getElementById('fileinput') as HTMLInputElement;
        if (fileElem && fileElem.value.length == 0) isLoading.value = false;
      };
      document.body.onfocus = function () {
        setTimeout(checkOnCancel, 100);
      };
    };
    const onFilePicked = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        file.value = target.files[0];
      }
    };
    const uploadState = ref({
      show: false,
      isValid: false,
      validEntriesQty: 0,
      invalidEntriesQty: 0
    });
    type UploadResponse = {
      isValid: boolean;
      validEntriesQty: number;
      invalidEntriesQty: number;
    };
    const setUploadState = (state: UploadResponse) => {
      uploadState.value.show = true;
      uploadState.value.isValid = state.isValid;
      uploadState.value.validEntriesQty = state.validEntriesQty;
      uploadState.value.invalidEntriesQty = state.invalidEntriesQty;
    };
    const uploadFile = async () => {
      isLoading.value = true;

      try {
        const req = await sendFile<UploadResponse>(
          '/ajustes-load', file.value, 'ajustes'
        );
        if (req.ok) {
          file.value = null;
          showToast('SUCCESS', 'Ajustes subidos exitosamente');
          await getListOfLoads();
        } else {
          showToast('ERROR', 'Error subiendo ajustes');
        }
        if (req.payload) {
          setUploadState(req.payload);        
        }
      } catch (error) {
        console.log(error);
        showToast('ERROR', 'Error cargando ajustes');
        setUploadState({
          isValid: false,
          validEntriesQty: 0,
          invalidEntriesQty: 0
        });
      } finally {
        isLoading.value = false;
      }
    };

    const deleteModalState = ref(false);
    const selectedToDelete = ref(0);
    const selectToDeleteFn = (i: number) => {
      selectedToDelete.value = i;
      deleteModalState.value = true;
    };
    const deleteBatchFn = async () => {
      const res = await makeRequest<{ ok: boolean }>(METHODS.DELETE, `guia-ajustes-batch/${selectedToDelete.value}`, true);
      if (res.ok) {
        showToast('SUCCESS', 'Carga eliminada exitosamente');
      } else {
        showToast('ERROR', 'Error eliminando carga');
      }
      selectedToDelete.value = 0;
      await getListOfLoads();
      deleteModalState.value = false;
    };
    const isValidating = ref(false);
    const validateFile = async () => {
      isValidating.value = true;
      try {
        const req = await sendFile<{ ok: boolean, errors: string[], payload: boolean }>(
          '/guia-ajustes-validate-batch', file.value, 'ajustes'
        );
        if (req.ok && req.payload) {
          showToast('SUCCESS', 'Archivo válido');
        } else {
          showToast('ERROR', 'Archivo contiene errores');
        }
      } catch (error) {
        console.log(error);
        showToast('ERROR', 'Error validando archivo');
      } finally {
        isValidating.value = false;
      }
    };
    const downloadModelFile = () => {
      const link = document.createElement('a');
      link.href = '/ajustes.xlsx';
      link.download = 'ajustes.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    type Batch = {
      date: string;
      batch: number;
      count: number;
    };
    const batches = ref<Batch[]>([]);
    const getListOfLoads = async () => {
      const req = await makeRequest<any>(METHODS.GET, 'guia-ajustes-batches', true);
      if (req.ok && req.payload) {
        batches.value = req.payload;
      } else {
        showToast('ERROR', 'Error cargando archivos');
      }
    };

    onMounted(async () => {
      await getListOfLoads();
    });
    
    return {
      file,
      isLoading,
      pickFile,
      onFilePicked,
      uploadFile,
      fileRef,
      charge,
      deleteModalState,
      deleteBatchFn,
      selectToDeleteFn,
      selectedToDelete,
      validateFile,
      isValidating,
      downloadModelFile,
      uploadState,
      batches
    };
  }
});
